import { PixiBase } from './pixiBase';
import { pixiResourceHelper } from '../../helpers/pixiResourceHelper';

export class PixiGameDrawer {
  constructor({ PIXI, Spine, config }) {
    PixiBase.PIXI = PIXI;
    PixiBase.Spine = Spine;
    this.pixiApplication = PixiBase.createApplication(config);
    this.stage = this.pixiApplication.stage;
  }

  setupContainers(containers) {
    this.stage.addChild(...containers);
  }

  loadResource({ resource, loader }) {
    // eslint-disable-next-line no-underscore-dangle
    const { source } = this._getFromMemo(resource);
    let loadedResourceCount = 0;
    return new Promise((resolve) => {
      source.forEach(({ name, path, config }) => {
        loader.add(name, path, config);
        loader.load(name).then((res) => {
          pixiResourceHelper.declareResources({ [name]: res });
          loadedResourceCount += 1;
          if (loadedResourceCount === resource.length) {
            resolve();
          }
        });
      });
    });
  }

  // eslint-disable-next-line no-underscore-dangle,class-methods-use-this
  _getFromMemo(resource) {
    const source = pixiResourceHelper.filter(resource);
    const declared = pixiResourceHelper.getDeclaredResources(resource);
    return { source, declared };
  }
}
